import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types'; // eslint-disable-line no-unused-vars
import styled from 'styled-components';

// Components //
import Text from 'components/Text';
import View from 'components/View';

const Callout = styled(View)`
  padding: 12px 12px 14px 12px;
  border-radius: 4px;
  background-color: ${ ({ isError, isSuccess, theme }) =>
  isSuccess ?
    theme.color.success
    : isError ?
      theme.color.error
      : 'rgba(0, 0, 0, 0.08)' };
  max-width: 560px;

  & ${ Text } {
    line-height: 20px;

    & b {
      font-weight: 800;
    }
  }
`;

Callout.propTypes = {

};

export default Callout;
